import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./SupermarketSoftware.css";

export default function SupermarketSoftware() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100, once: true });
  }, []);

  const features = [
    { icon: "🛒", title: "POS Billing System" },
    { icon: "📦", title: "Inventory Control" },
    { icon: "🏬", title: "Multi-Branch Management" },
    { icon: "📊", title: "Sales Reporting" },
    { icon: "💳", title: "Customer Billing System" },
    { icon: "🔐", title: "Role-Based Access" },
  ];

  const benefits = [
    { icon: "⚡", title: "Fast Checkout System" },
    { icon: "📉", title: "Reduce Stock Wastage" },
    { icon: "📈", title: "Increase Sales Efficiency" },
    { icon: "💰", title: "Boost Profit Margins" },
  ];

  const industries = [
    "Supermarkets",
    "Hypermarkets",
    "Retail Stores",
    "Mini Marts",
    "Grocery Chains",
    "Wholesale Shops",
  ];

  const faqs = [
    {
      q: "What is supermarket software?",
      a: "It is a complete POS and inventory system designed to manage billing, stock, and sales in supermarkets.",
    },
    {
      q: "Does it support barcode scanning?",
      a: "Yes, it fully supports barcode-based billing and stock management.",
    },
  ];

  return (
    <div className="supermarket-page">
      {/* HERO */}
      <section className="hero" data-aos="fade-up">
        <h1>
          Supermarket <span>Software</span>
        </h1>
        <p>
          Advanced <b>POS, ERP & Inventory Management System</b> designed for
          supermarkets, grocery stores, and retail chains to manage billing,
          stock, and sales in real-time.
        </p>
      </section>

      {/* INTRO */}
      <section className="intro" data-aos="fade-up">
        <p className="gradient-text">
          A powerful supermarket management system that automates billing,
          inventory tracking, purchase management, and sales reporting for
          modern retail businesses and chains.
        </p>
      </section>

      {/* FEATURES */}
      <section className="section">
        <h2 data-aos="fade-up">Features</h2>

        <div className="grid">
          {features.map((f, i) => (
            <div className="card" key={i} data-aos="zoom-in">
              <div className="icon">{f.icon}</div>
              <h3>{f.title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* BENEFITS */}
      <section className="section">
        <h2 data-aos="fade-up">Benefits</h2>

        <div className="grid">
          {benefits.map((b, i) => (
            <div className="card" key={i} data-aos="fade-up">
              <div className="icon">{b.icon}</div>
              <h3>{b.title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="section">
        <h2 data-aos="fade-up">Industries</h2>

        <div className="industry-grid">
          {industries.map((item, i) => (
            <div className="industry-box" key={i} data-aos="zoom-in">
              {item}
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="section">
        <h2 data-aos="fade-up">FAQs</h2>

        <div className="faq">
          {faqs.map((f, i) => (
            <div className="faq-item" key={i} data-aos="fade-up">
              <h4>{f.q}</h4>
              <p>{f.a}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta" data-aos="zoom-in">
        <h2>Upgrade Your Supermarket System Today</h2>
        <p>
          Get a complete POS + Inventory + ERP solution for your retail
          business.
        </p>
        <a href="/contact" className="btn">
          Get Free Consultation
        </a>
      </section>
    </div>
  );
}
